import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "right-part" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "content" }

import TopNavigation from "@/components/layout/TopNavigation.vue";
import SidebarMenu from "@/components/layout/SidebarMenu.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ContainerView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SidebarMenu)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TopNavigation)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_view, { class: "router-view-container" })
      ])
    ])
  ]))
}
}

})